import styles from "./statusCodeFilterResult.module.scss";
import { TransformExecuteResponse } from "../../types/clientTypes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import {
  useEffect,
  useMemo,
  useState
} from "react";
import {
  useForm,
  useWatch
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  number,
  object
} from "yup";
import { Dropdown } from "../../shared/components/dropdown/dropdown";
import { ReactComponent as ArrowSvg } from "../../shared/images/arrow.svg";
import { StatusCode } from "../../types/sharedTypes";

export type PassedAndFailedResultProps = {
  executeResponses: Array<TransformExecuteResponse>;
  filter?: StatusCode;
  onChangeFilter: (statusCode?: StatusCode) => void;
}

export const StatusCodeFilterResult = ({ executeResponses, filter, onChangeFilter }: PassedAndFailedResultProps) => {
  const { t } = useTranslation();

  const statusCodes = useSelector((state: RootState) => state.mainSlice.statusCodes);

  const [isOpenDropdown, setIsOpenDropdown] = useState<boolean>(false);

  const schema = object({
    statusCode: number().required(),
  });

  const { control, setValue } = useForm({
    resolver: yupResolver(schema)
  });
  const statusCodeWatch = useWatch({ control, name: "statusCode" });

  useEffect(() => {
    setValue("statusCode", filter?.id || 0)
  }, [filter, setValue]);

  useEffect(() => {
    onChangeFilter(statusCodes?.find(item => item.id === statusCodeWatch));
  }, [statusCodeWatch, onChangeFilter]);

  const dropdownItems = useMemo(() => {
    const result = [{
      id: 0,
      name: t("common.all"),
      title: t("common.all")
    }];

    executeResponses.forEach(executeResponse => {
      const statusCode = statusCodes.find(item => item.code === executeResponse.statusCode);
      if (!!statusCode) {
        const findItem = result.find(item => item.id === statusCode.id);
        if (!findItem) {
          result.push({
            id: statusCode.id,
            name: `${statusCode.code} ${statusCode.name}`,
            title: `${statusCode.code} ${statusCode.name}`
          })
        }
      }
    });
    return result;
  }, [statusCodes, executeResponses]);

  const statusCode: string = useMemo(() => {
    if (!!statusCodeWatch) {
      const statusCode = statusCodes.find(item => item.id === statusCodeWatch);
      if (!!statusCode) {
        return `${statusCode.code} ${statusCode.name}`
      } else {
        console.error("Error show status code");
        return ""
      }
    } else {
      return t("common.statusCode");
    }
  }, [statusCodeWatch, statusCodes]);

  return (
      <>
        <div className={styles.container} onClick={(e) => e.stopPropagation()}>
          <div className={styles.dropdown}>
            <Dropdown items={dropdownItems}
                      fontPopupClass={styles.fontPopup}
                      isOpenProp={isOpenDropdown}
                      setIsOpenProp={setIsOpenDropdown}
                      name={"statusCode"}
                      control={control}/>
          </div>
          {statusCode}
          <ArrowSvg className={isOpenDropdown ? styles.open : ""}/>
        </div>
      </>

  );
}